/**
 * g2-brush
 * @author sima.zhang1990@gmail.com
 */
var Brush = require('./src/brush');
module.exports = Brush;


//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 0
// module chunks = 0